<template>
    <div>
        <div class="pb-24">
            <h2 class="text-xl pb-3">Payment Pending...</h2>
            <span class="pb-4 text-lg block">{{userMessage}}</span>
        </div>
        <Spinner />
    </div>
</template>

<script>

    import Spinner from './../components/Spinner.vue';

    let dict = {
        'PRESENT_CARD': 'Insert/Tap Card',
        'INSERT_CARD': 'Insert card',
        'PLEASE_WAIT': 'Connecting to bank',
        'CONNECTING': 'Connecting to bank',
        'CONNECTION_MADE': 'Connection successful',
        'RETRYING': 'Retrying connection',
        'PIN_ENTRY': 'Enter PIN',
        'APPROVED': 'Payment approved',
        'REMOVE_CARD': 'Please remove card',
        'BAD_SWIPE': 'Bad swipe, try again',
        'PAPER_OUT': 'No paper in the card machine!',
        'CARD_ERROR': 'Card error, please try again',
        'UNSUPPORTED': 'Unsupported payment type',
    };

    export default {
        name: 'payment-pending',
        components: {
            Spinner
        },
        computed: {
            userMessage() {
                let status = this.$route.query.status;
                if (dict[status]) {
                    return dict[status];
                }
                else {
                    return '';
                }
            }
        }
    }

</script>